import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '@/contexts/AuthContext';

const RoleRedirect = () => {
  const {user} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const currentPath = window.location.pathname;
      const role = (user.role || '').toString().toLowerCase();

      // If user is on the root path, redirect based on role
      if (currentPath === '/') {
        if (role === 'participant') {
          navigate('/participant', {replace: true});
        } else if (role === 'moderator') {
          navigate('/moderator', {replace: true});
        } else if (role === 'project_manager' || role === 'admin' || role === 'scheduler') {
          // PM, Admin, Scheduler stay on root (dashboard / projects)
        } else {
          // Fallback for users without a recognized role
          navigate('/participant', {replace: true});
        }
      }
    }
  }, [user, navigate]);

  return null; // This component doesn't render anything
};

export default RoleRedirect;
